<div class="sk-cms-mimage-wap"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
    {{/if}}

    {{if !content || content.length == 0}}
    <% include('../common/nodata.art') %>
    {{else}}
    <div class="mimage-main">
        {{if basic.style.type == 'column2'}}
        <div class="swiper-container sk-j-mimage">
            <div class="swiper-wrapper">
                {{each content}}
                <div class="swiper-slide">
                    {{if $value.linkType != 'none' && !isDesign}}
                    <a class="goto-link" target="_blank" href="{{$value.link}}">
                    {{/if}}
                    <img src="{{$value.imgUrl}}" alt="">
                    {{if $value.linkType != 'none' && !isDesign}}
                    </a>
                    {{/if}}
                </div>
                {{/each}}
            </div>
        </div>
        {{else}}
        <div class="mimage-wrap mimage-{{basic.style.type}}" style="{{style.isShowMargin != 1 ? 'grid-row-gap: 0;grid-column-gap: 0;' : ''}};">
            {{each content}}
            <div class="mimage-item">
                {{if $value.linkType != 'none' && !isDesign}}
                <a class="goto-link" target="_blank" href="{{$value.link}}">
                {{/if}}
                    <img src="{{$value.imgUrl}}" alt="">
                {{if $value.linkType != 'none' && !isDesign}}
                </a>
                {{/if}}
            </div>
            {{/each}}
        </div>
        {{/if}}
    </div>
    {{/if}}
</div>
